import { createSlice } from "@reduxjs/toolkit";
import { IAcademicProfileSlice } from "../../../models/student/studentAcademicProfile";

const initialAcademicProfileState: IAcademicProfileSlice = {
  academicDetails: undefined,
};

const academicProfileSlice = createSlice({
  name: "academicProfile",
  initialState: initialAcademicProfileState,
  reducers: {
    setAcademicDetails: (state, action: { payload: any }) => {
      state.academicDetails = action.payload;
    },
  },
});

export const { setAcademicDetails } = academicProfileSlice.actions;

const academicProfilesReducer = academicProfileSlice.reducer;

export type academicProfileState = ReturnType<typeof academicProfilesReducer>;

export default academicProfilesReducer;